// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Layout_main-container__17NFA","with-sidebar":"Layout_with-sidebar__sGsMJ"};